<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title" id="exampleModalLabel1">Crear cuenta maestra</h4>
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      mat-dialog-close
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="form">
      <div class="row">
        <div class="col-12 col-md-6">
          <!-- TITULAR -->
          <mat-form-field style="width: 100%;">
            <mat-label>Titular</mat-label>
            <input
              type="text"
              formControlName="titular"
              matInput
              placeholder="Ingrese el titular"
            />
            <mat-error *ngIf="form.get('titular').hasError('required')"
              >El titular es <strong>requerido</strong></mat-error
            >
            <mat-error *ngIf="form.get('titular').hasError('pattern')"
              >El titular es <strong>invalido</strong></mat-error
            >
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
          <!-- TIPO DE DOCUMENTO -->
          <mat-form-field class="custom-select-form" style="width: 100%;">
            <mat-label>Tipo de documento</mat-label>
            <mat-select formControlName="tipo_documento">
              <mat-option
                *ngFor="let tipo of tiposDocumentos"
                [value]="tipo.name"
              >
                {{ tipo.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('tipo_documento').hasError('required')"
              >EL tipo documento es <strong>requerida</strong></mat-error
            >
            <mat-error *ngIf="form.get('tipo_documento').hasError('maxlength')"
              >EL tipo documento debe tener solo un
              <strong>caracter</strong></mat-error
            >
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
          <!-- NUMERO DE CUENTA -->
          <mat-form-field style="width: 100%;">
            <mat-label>Número de Cuenta</mat-label>
            <input
              type="text"
              formControlName="numero_cuenta"
              matInput
              placeholder="Ingrese su numero de cuenta"
            />
            <mat-error *ngIf="form.get('numero_cuenta').hasError('required')"
              >La cuenta es <strong>requerida</strong></mat-error
            >
            <mat-error *ngIf="form.get('numero_cuenta').hasError('pattern')"
              >La cuenta es <strong>invalida</strong></mat-error
            >
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
          <!-- PAGO MOVIL -->
          <mat-form-field style="width: 100%;">
            <mat-label>Pago Movil</mat-label>
            <input
              type="text"
              formControlName="pago_movil"
              matInput
              placeholder="Ingrese el pago movil"
            />
            <mat-error *ngIf="form.get('pago_movil').hasError('required')"
              >El pago movil es <strong>requerida</strong></mat-error
            >
            <mat-error *ngIf="form.get('pago_movil').hasError('pattern')"
              >El pago movil es <strong>invalida</strong></mat-error
            >
            <mat-error *ngIf="form.get('pago_movil').hasError('maxlength')"
              >la cantidad de digitos del pago movil debe ser
              <strong> de 11</strong></mat-error
            >
            <mat-error *ngIf="form.get('pago_movil').hasError('minlength')"
              >la cantidad de digitos del pago movil debe ser
              <strong> de 11</strong></mat-error
            >
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
          <!-- NUMERO DE DOCUMENTO -->
          <mat-form-field style="width: 100%;">
            <mat-label>Documento</mat-label>
            <input
              type="text"
              formControlName="numero_documento_cuenta"
              matInput
              placeholder="Ingrese su Documento"
            />
            <mat-error
              *ngIf="form.get('numero_documento_cuenta').hasError('required')"
              >El Documento es <strong>requerido</strong></mat-error
            >
            <mat-error
              *ngIf="form.get('numero_documento_cuenta').hasError('pattern')"
              >El Documento es <strong>invalido</strong></mat-error
            >
          </mat-form-field>
        </div>
      </div>

      <button
        (click)="onSubmit()"
        class="btn btn-info waves-effect float-right"
        [disabled]="form.status != 'VALID'"
      >
      <i class="far fa-save"></i>
        Guardar
      </button>
    </form>
  </div>
</div>
